import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Ticket } from '../../services/ticket.service';

@Component({
    selector: 'app-ticket-summary-tile',
    templateUrl: './ticket-summary-tile.component.html',
    styleUrls: ['./ticket-summary-tile.component.sass'],
    standalone: false
})
export class TicketSummaryTileComponent {
  @Input() ticket!: Ticket;

  constructor(private router: Router, private route: ActivatedRoute) { }

  getStatusTranslation(status: string): string {
    const translations: { [key: string]: string } = {
      'OPEN': 'Aberto',
      'IN_PROGRESS': 'Em andamento',
      'CLOSED': 'Fechado'
    };
    return translations[status] || status;
  }

  navigateToTicket(): void {
    let condominiumId = this.route.parent?.snapshot.paramMap.get('id');
    this.router.navigate(['/condominium', condominiumId, 'ticket', this.ticket.id]);
  }
}
